module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Blurb-rw",
    attrs: {
      "epub:type": "frontmatter",
      "id": "Blurb1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block3"
    }
  }, [_c('p', {
    attrs: {
      "id": "p3"
    }
  }, [_vm._v("“I meant it when I said that I’ve got you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p4"
    }
  }, [_vm._v("With his free hand, Sean tucked a strand of hair behind Sierra’s ear, tracing his thumb over her cheekbone. His eyes drifted down to her lips, and he couldn’t fight it anymore. Clearly he was hell-bent on destruction tonight, because for the first time in his ten years as a bodyguard, he was going to kiss a client.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p5"
    }
  }, [_vm._v("Cupping her cheek with his uninjured hand, he slowly dipped his head and gently, tenderly closed his mouth over hers. She responded immediately, returning the kiss with a soft sigh.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p6"
    }
  }, [_vm._v("Finally he was touching her and tasting her just the way he’d wanted since the day they met. Finally, and it was a thousand times better than he ever could’ve imagined. And he’d spent a lot of time imagining it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p7"
    }
  }, [_vm._v("It was the best wrong thing he’d ever done.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7675419b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s001-Blurb-01.vue
// module id = 60
// module chunks = 0